'use client';

import { c as _c } from "react/compiler-runtime";
import { GiftVariantModal } from './gift-variant-modal';
import { HydrateBundlePanel } from './hydrate-bundle/hydrate-bundle-panel';
import { ProductInfoBase, type ProductInfoProps } from './product-info';
import { PurchaseOptionSelector } from './purchase-option-selector';
const subscriptionComponents = {
  HydrateBundlePanel,
  PurchaseOptionSelector,
  GiftVariantModal
};
export function SubscriptionProductInfo(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ProductInfoBase {...props} subscriptionComponents={subscriptionComponents} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}